import { z, ZodType } from 'zod';
import { entityWithNameSchema } from './entity-with-name';
import { Shift } from './shift';
import { ShiftPersonal } from './shift-personal';
import { ShiftTotal } from './shift-total';

export type ShiftExtended = Shift & ShiftPersonal & ShiftTotal;

export const shiftExtendedSchema: ZodType<ShiftExtended> = z.object({
	id: z.string(),
	openingBalance: z.number(),
	closingBalance: z.number(),
	currency: z.string(),
	isActive: z.boolean(),
	owner: entityWithNameSchema,
	deposits: z.number(),
	withdrawals: z.number(),
	income: z.number(),
	totalDeposits: z.number(),
	totalWithdrawals: z.number(),
	totalIncome: z.number(),
});
